"use client"

import SinAuth from "../templates/SinAuth";
import ContenidoPublico from "../templates/ContenidoPublico";
import TemplateGuest from "../templates/TemplateGuest";

import { connect } from "react-redux";
import dynamic from 'next/dynamic';

import BlocksGuestUserURL from "../components/BlocksGuestUserURL";
import "primereact/resources/primereact.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "prismjs/themes/prism-coy.css";
import "../assets/demo/flags/flags.css";
import "../assets/demo/Demos.scss";
import "../assets/layout/layout.scss";
import "../App.scss";

import React, { useState, useEffect, useRef } from "react";

//import { configSubdomain, useAuthDispatch, logout, useAuthState } from '../context';


const GuestUserURL = (props) => {
    console.log("GuestUserURLfff.js");

    //const dispatch = useAuthDispatch();
    //const userDetails = useAuthState();

    //const { subdomain, userName, idSuscripcion, idEmpresa, idioma } = userDetails;
    const [comodin, setComodin] = useState(0);

    const onLoginGuest = (_genericaSistema) => {
        console.log("Nuevo login");
        setComodin(x => x + 1);
    }

    return (
        <ContenidoPublico>
            <BlocksGuestUserURL onLoginGuest={onLoginGuest} />
        </ContenidoPublico>
    );
};

/*return (
        <TemplateGuest>
            <BlocksGuestUserURL />
        </TemplateGuest>
    );
    */

//export default GuestUserURL;
export default dynamic(() => Promise.resolve(connect(null)(GuestUserURL)), { ssr: false });